import { baseActionEpic, IRequestAction, IRequestDataAction, progressEpic } from "epics/base-epic";
import { format as t } from "lib/globalize-util";
import { INVENTORY_DATA } from "constants/action-types";
import siteConfig from "site-config";
import { add as snackbarAdd } from "actions/snackbars";
import { IStore } from "reducers";
import { update } from "actions/inventory-data-actions";

export const uploadInventory = progressEpic<IRequestDataAction, null>(
    INVENTORY_DATA.UPLOAD_NON_VETL,
    ({ payload }) => ({
        method: "PUT",
        url: siteConfig.api + payload.url,
        body: payload.body,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            module: "default",
            Accept: "application/json",
        },
    }),
    {
        dataCustomizer: () => null,
        finishActions: () => [update({ uploadFinished: true })],
    }
);

export const downloadInventory = baseActionEpic<IRequestDataAction>(
    INVENTORY_DATA.DOWNLOAD,
    ({ payload }) => ({ method: "POST", url: siteConfig.api + payload.url, body: payload.body }),
    // TODO: for consistency this needs to dispatch id and link should be built in <ExportInitiationResult />
    ({ response }, action, store: IStore) => [
        update({ isLoading: false, link: `/brand/${store.scope.brand._id}/inventory/export/${response.id}` }),
    ],
    {
        errorActions: () => [update({ isLoading: false })],
    }
);

export const downloadATSInventory = baseActionEpic<IRequestDataAction>(
    INVENTORY_DATA.DOWNLOAD_ATS,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url }),
    ({ response }) => [update({ isLoading: false, link: response.url })],
    {
        errorActions: () => [update({ isLoading: false })],
    }
);

export const deleteAllInventory = baseActionEpic<IRequestAction>(
    INVENTORY_DATA.DELETE_ALL,
    ({ payload }) => ({ method: "DELETE", url: siteConfig.api + payload.url }),
    () => [snackbarAdd({ message: t("Inventory is removed") })]
);
